import React, {
    Component
  } from 'react';
  import {
    connect
  } from 'react-redux';
  
  import Button from '../../../components/UI/Button/Button';
  import Spinner from '../../../components/UI/Spinner/Spinner';
  import classes from './ProgressBar.css';
  import Box from '../../../hoc/Box/Box';
  import axios from '../../../axios-local-api';
  import Input from '../../../components/UI/Input/Input';
  import withErrorHandler from '../../../hoc/withErrorHandler/withErrorHandler'
  import * as actions from '../../../store/actions/index';
  import {
    updateObject,
    checkValidity
  } from '../../../shared/utility';
  
  class ProgressBar extends Component {
    constructor(props) {
        super(props)
        
        this.state = {
          percentage: 0
        }
        this.nextStep = this.nextStep.bind(this)
      }
      
      nextStep() {
        if(this.state.percentage === 100) return 
        this.setState({ percentage: this.state.percentage + 20 })
      }
      
      render() {
        return (
          <div>
            
            <div style = {{ fontSize:18, color:'gray' }}>Rebooting</div>
            <ProgressBar percentage={this.state.percentage} />
            
            <div style={{ marginTop: '20px' }}>  
              <button 
                onClick={this.nextStep}
               >
                Next Step
              </button>  
            </div>   
            
            {/* Added for convenience of viewing */}
            <div style={{ marginTop: '10px', color: 'blue', marginBottom: '15px' }} onClick={() => this.setState({ percentage: 0 })}>
              Reset
            </div>
          </div>
        )
      }  
    }
    
    const ProgressBarConst = (props) => {
      return (
          <div className="progress-bar">
            <Filler percentage={props.percentage} />
          </div>
        )
    }
    
    const Filler = (props) => {
      return <div className="filler" style={{ width: `${props.percentage}%` }} />
    }
  
  const mapStateToProps = state => {
    return {
    }
  };
  
  const mapDispatchToProps = dispatch => {
    return {
    };
  };
  
  export default connect(mapStateToProps, mapDispatchToProps)(withErrorHandler(ProgressBarConst, axios));
  